import { Component } from 'react';
import { Route } from 'react-router';
import history from '../../../shared/History';
import { IProtectedRouteProps } from './IProtectedRouteProps';

class ProtectedRoute extends Component<IProtectedRouteProps> {

    constructor(props: IProtectedRouteProps) {
        super(props);

        const LoadRoute: boolean = props.predicate;
        if (!LoadRoute) history.replace(props.fallback);
    }

    public render = () => (!this.props.predicate ? null : (<Route {...this.props} />))
}

export default ProtectedRoute;